import React from 'react';
import styled from 'styled-components';

const Circle = styled.div`
  text-align: center;
  line-height: 1;
  border: 1px solid #333;
  border-radius: 100%;
  width: 20px;
  height: 20px;

  @media screen and (max-width: 1200px), screen and (max-height: 700px) {
    width: 16px;
    height: 16px;
  }
`;

const Text = styled.div`
  grid-column: 2;
`;

interface Props {
  num: number;
  title: string;
}

export default (props: Props) => {
  const {num, title} = props;
  return(
    <>
      <Circle>
        {num}
      </Circle>
      <Text>
        {title}
      </Text>
    </>
   );
};
